// Shared invoice-status rules for the Billing Settlement UI. Statuses follow the API
// (Prepared / Approved / Sent / Partially Paid / Paid / Returned / Cancelled); Cancelled invoices are
// kept for audit but excluded from every total.
import type { Invoice, InvoiceStatus } from '@/redux/internal-services/jobsApi';

const TERMINAL_EXCLUDED: ReadonlySet<InvoiceStatus> = new Set<InvoiceStatus>(['Cancelled']);

/** True when the invoice counts toward invoiced / paid / outstanding totals. */
export const isActiveInvoice = (inv: Pick<Invoice, 'status'>): boolean => !TERMINAL_EXCLUDED.has(inv.status);
